/**
 * This file is part of the WebThemeListener package. It provides context
 *  for the theme of the application. It is used to provide the theme
 *  to the application and to listen for changes in the theme via
 *  window.postMessage.
 *
 * It depends on the AppThemeProvider and the useAppTheme hook to
 *  override the default theme colors and to provide the theme
 */

import { useEffect } from 'react';
import { useAppTheme } from '../AppThemeProvider';
import { useAppImages } from '../AppImagesProvider';

const WebThemeListener = () => {
  const { previewThemeSet, setMode } = useAppTheme();
  const { setAppImages } = useAppImages();

  useEffect(() => {
    const handleThemeChange = (event: MessageEvent) => {
      let expectedOrigin: string = '';
      if (window.location.hostname === 'localhost') {
        expectedOrigin = 'http://localhost:3000';
      } else if (window.location.hostname === 'practices.staging.allydvm.com') {
        expectedOrigin = window.location.origin.replace(/practices.staging/, 'staging');
      } else {
        expectedOrigin = window.location.origin.replace(/practices/, 'connect');
      }
      if (event.origin !== expectedOrigin) {
        return;
      }
      if (event.data && event.data.type === 'theme') {
        const theme = event.data.theme;
        previewThemeSet(theme);
      }
      if (event.data && event.data.type === 'mode') {
        const mode = event.data.mode;
        if (mode === 'light' || mode === 'dark') {
          setMode(mode);
        }
      }
      if (event.data && event.data.type === 'reset') {
        previewThemeSet(undefined);
        setMode(undefined);
      }
      if (event.data && event.data.type === 'images') {
        setAppImages(event.data.images);
      }
    };

    window.addEventListener('message', handleThemeChange);

    return () => {
      window.removeEventListener('message', handleThemeChange);
    };
  }, [previewThemeSet, setMode, setAppImages]);

  return null;
};

export default WebThemeListener;
